var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPost(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 149.995,
    height: 150,
    viewBox: "0 0 149.995 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42112",
    "data-name": "Group 42112",
    transform: "translate(-234.579 -253.588)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20932",
    "data-name": "Path 20932",
    d: "M384.569,328.731q0,18.153,0,36.3c-.028,22.159-16.309,38.513-38.391,38.537q-36.593.037-73.185,0c-21.959-.024-38.362-16.358-38.387-38.244q-.049-36.739,0-73.478c.024-21.9,16.419-38.224,38.382-38.244q36.6-.031,73.189,0c22.081.02,38.362,16.375,38.391,38.533Q384.59,310.436,384.569,328.731Zm-74.891-62.667q-18.006,0-36.008,0c-15.979.02-26.595,10.635-26.607,26.627q-.03,35.866,0,71.731c.008,16,10.619,26.668,26.558,26.68q36.012.031,72.02,0c15.784-.016,26.444-10.684,26.46-26.484q.031-36.012,0-72.024c-.016-15.825-10.652-26.5-26.411-26.529C333.686,266.043,321.682,266.064,309.678,266.064Z",
    transform: "translate(0 0)",
    fill: "#674188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20933",
    "data-name": "Path 20933",
    d: "M287.655,306.591c0,8,.016,15.5-.02,23.006a14.627,14.627,0,0,1-.4,3.756,6.144,6.144,0,0,1-11.776.053,14.43,14.43,0,0,1-.4-3.752c-.037-7.511-.021-15.022-.021-22.912-1.132-.053-2.155-.142-3.177-.142-7.124-.016-14.244.02-21.368-.033a6.2,6.2,0,0,1-6.081-3.784c-1.063-2.379-.884-4.913,1.047-6.46a10.853,10.853,0,0,1,6.008-2.24c7.69-.257,15.393-.1,23.43-.1.053-1.193.134-2.22.139-3.25.012-6.831-.02-13.658.016-20.488.02-4.64,2.538-7.515,6.407-7.442,3.76.069,6.159,2.876,6.183,7.381.037,7.788.008,15.576.008,23.8h3.32c6.831,0,13.662-.024,20.493.012,4.5.024,7.3,2.432,7.365,6.191.065,3.87-2.806,6.379-7.45,6.4-6.733.037-13.466.012-20.2.012Z",
    transform: "translate(28.235 28.303)",
    fill: "#674188"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPost);
export default __webpack_public_path__ + "static/media/Post.0f106b53699dce865c5b0fdba602c288.svg";
export { ForwardRef as ReactComponent };